import { useFormContext, Controller, ValidationRule } from 'react-hook-form';
import { TextField, TextFieldProps } from '@mui/material';
import { forwardRef, useState } from 'react';

type Props = TextFieldProps & {
  name: string;
  testId: string;
  rules?: { [key: string]: ValidationRule | ValidationRule[] };
  customHelperText?: string;
};

export const RHFTextField = forwardRef(
  (
    {
      name,
      testId,
      rules,
      customHelperText = '',
      onFocus,
      InputProps,
      inputProps: additionalInputProps = {},
      ...other
    }: Props,
    ref
  ) => {
    const { control } = useFormContext();
    const [isAutoFill, setIsAutoFill] = useState(false);

    const mergedInputProps = {
      ...additionalInputProps,
      'data-sm': testId,
      'data-testid': testId,
    };

    return (
      <Controller
        name={name}
        control={control}
        rules={rules}
        defaultValue=""
        render={({ field, fieldState: { error } }) => (
          <TextField
            {...field}
            // TODO: needs to be added and tested on every form before enabling globally —
            // without this, browser autofill may not mark fields as dirty in RHF.
            // onChange={(e) => {
            //   field.onChange(e);
            //   setValue(name, e.target.value, { shouldDirty: true });
            // }}
            inputRef={ref}
            inputProps={mergedInputProps}
            InputLabelProps={{ shrink: isAutoFill || undefined }}
            InputProps={{
              ...InputProps,
              inputProps: {
                ...mergedInputProps,
              },
              onAnimationStart: (e: React.AnimationEvent<HTMLDivElement>) => {
                e.animationName === 'mui-auto-fill' && setIsAutoFill(true);
              },
              onAnimationEnd: (e: React.AnimationEvent<HTMLDivElement>) =>
                e.animationName === 'mui-auto-fill-cancel' && setIsAutoFill(false),
              onFocus: (e) => {
                setIsAutoFill(false);
                if (onFocus) {
                  onFocus(e);
                }
              },
            }}
            fullWidth
            value={typeof field.value === 'number' && field.value === 0 ? '' : field.value || ''}
            error={!!error}
            helperText={error?.message || customHelperText}
            {...other}
          />
        )}
      />
    );
  }
);
